import {cs}          from "../../react/chain-services";
import {fragments}   from "../../react/fragments";
import {Invoke}      from "../../react/invoke";
import {scnv}        from "../../react/state-change-nested-value";
import {UseState}    from "../../react/use-state";
import {waitTimeout} from "../../utils/wait-timeout";

export const DownwardTransitioning = ({value, compare=(v1, v2)=>v1===v2, next}) => cs(
    ["state", (_, next) => UseState({
        getInitValue: () => ({
            oldValue: value,
        }),
        next,
    })],
    ({state}) => fragments(
        next(!compare(state.value.oldValue, value) ? {
            active: true,
            toValue: value,
            fromValue: state.value.oldValue,
            starting: !state.value.inProgress,
        } : {
            active: false
        }),
        !compare(state.value.oldValue, value) && fragments(
            Invoke({
                action: async ({isMounted}) => {
                    await waitTimeout(10);
                    if (!isMounted()) return;

                    scnv(state, ["inProgress"], () => true);

                    await waitTimeout(300);

                    state.onChange({oldValue: value});
                },
            })
        )
    ),
);
